import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'MonCakeSwap',
  description:
    'The most popular AMM on BSC by user count! Earn CAKE through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by PancakeSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://monswap.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('MoncakeSwap')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('MoncakeSwap')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('MoncakeSwap')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('MoncakeSwap')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('MoncakeSwap')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('MoncakeSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('MoncakeSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('MoncakeSwap')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('MoncakeSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('MoncakeSwap')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('MoncakeSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('MoncakeSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('MoncakeSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('MoncakeSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('MoncakeSwap')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('MoncakeSwap')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('MoncakeSwap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('MoncakeSwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('MoncakeSwap Info & Analytics')}`,
        description: 'View statistics for MoncakeSwap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('MoncakeSwap Info & Analytics')}`,
        description: 'View statistics for MoncakeSwap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('MoncakeSwap Info & Analytics')}`,
        description: 'View statistics for MoncakeSwap exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('MoncakeSwap')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('MoncakeSwap')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')} | ${t('MoncakeSwap')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')} | ${t('MoncakeSwap')}`,
      }
    default:
      return null
  }
}
